import { render, staticRenderFns } from "./informationManage.vue?vue&type=template&id=dcadb8d0&scoped=true&"
import script from "./informationManage.vue?vue&type=script&lang=js&"
export * from "./informationManage.vue?vue&type=script&lang=js&"
import style0 from "./informationManage.vue?vue&type=style&index=0&id=dcadb8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcadb8d0",
  null
  
)

export default component.exports